const HUMAN_MEDICINE_DELIMITATION = 'enum.sale_delimitation.humanmedizinisch'

export const useHumanMedicineRestriction = () => {
  const userStore = useUserStore()

  const isHumanMedicineRestricted = (
    saleDelimitations: string[] | undefined | null,
  ): boolean => {
    return !!saleDelimitations?.includes(HUMAN_MEDICINE_DELIMITATION)
      && !userStore.data?.pharmacyRegistrationCertificateKey
  }

  return { isHumanMedicineRestricted }
}
